/**
 * Thèmes, types d'activité et « Association sportive »… dans la langue de la
 * page.
 *
 * Les tables de `@donoor/utils` (THEMES, TYPES_ACTIVITE, libelleAssociation)
 * sont en français : elles servent aussi aux URL, au référencement et à la
 * base. Ici on ne change que le LIBELLÉ affiché (clés `commun.themes.*`,
 * `commun.typesActivite.*`, `commun.associationParTheme.*`, mêmes textes que
 * l'app mobile). Une valeur inconnue retombe sur le libellé français.
 *
 * Lu au moment de l'affichage (jamais au chargement du module), pour suivre
 * la langue courante.
 */
import {
  libelleAssociation,
  libelleTheme,
  libelleTypeActivite,
  themeDepuisCategorie,
} from "@donoor/utils";

function traduit(cle: string, repli: string): string {
  const i18n = useNuxtApp().$i18n;
  return i18n.te(cle) ? i18n.t(cle) : repli;
}

/** « Sport », « Arts & Culture »… — accepte aussi les anciennes catégories. */
export function themeAffiche(categorie: string | null | undefined): string {
  const theme = themeDepuisCategorie(categorie);
  return traduit(`commun.themes.${theme}`, libelleTheme(theme));
}

/** « Concerts », « Ateliers »… */
export function typeActiviteAffiche(type: string | null | undefined): string {
  return traduit(`commun.typesActivite.${type ?? "autre"}`, libelleTypeActivite(type));
}

/** « Association sportive », « Association culturelle »… */
export function associationAffichee(categorie: string | null | undefined): string {
  const theme = themeDepuisCategorie(categorie);
  return traduit(`commun.associationParTheme.${theme}`, libelleAssociation(categorie));
}
